import { render, staticRenderFns } from "./dialog-consent-etax-status.vue?vue&type=template&id=19a9f6c2&"
import script from "./dialog-consent-etax-status.vue?vue&type=script&lang=js&"
export * from "./dialog-consent-etax-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports